<script lang="ts" setup>
import type { PlanktonCategoryWithSlugs } from "~~/server/plankton";

const { category } = defineProps<{
  category?: PlanktonCategoryWithSlugs | null | undefined;
}>();

const { locale } = useI18n();

const { data: seoTexts } = await useFetch("/api/cms/category-seo-text", { query: { locale: locale, categoryId: category?.id } }) ?? [];
</script>

<template>
  <hr class="border-neutral-200">
  <div v-if="seoTexts?.length" class="gap-xl lg:gap-3xl grid grid-cols-1 md:grid-cols-2">
    <div v-for="seoText in seoTexts" :key="seoText.title">
      <h2 class="text-lg font-semibold">
        {{ seoText.title }}
      </h2>
      <div class="html-content text-balance" v-html="seoText.text" />
    </div>
  </div>
</template>

<style scoped>
</style>
